// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "immutable/" + chunkId + "." + {"3":"32e5137d44dbdae9cf09","97":"6d93975f45aad6baf65d","98":"f2232b7173f269bae403","819":"74b856f60dfb0aa95cdc"}[chunkId] + ".chunk.css";
};